export function getEnv(key: string): string {
  const config = (window as any).config || {};
  let configKey = key;
  if (key.startsWith("VITE_APP_")) {
    configKey = key
      .replace("VITE_APP_", "")
      .toLowerCase()
      .replace(/_([a-z])/g, (g) => g[1].toUpperCase());
  } else if (key.startsWith("VITE_")) {
    configKey = key
      .replace("VITE_", "")
      .toLowerCase()
      .replace(/_([a-z])/g, (g) => g[1].toUpperCase());
  }

  if (config[configKey] && config[configKey] !== `\${${key}}`) {
    return config[configKey];
  }

  return import.meta.env[key] || "";
}

export const env = {
  VITE_APP_BASE_API_URL: getEnv("VITE_APP_BASE_API_URL"),
  VITE_APP_SMARTBPM_URL: getEnv("VITE_APP_SMARTBPM_URL"),
  VITE_APP_DOCUMENTOS_URL: getEnv("VITE_APP_DOCUMENTOS_URL"),
  VITE_APP_SCANNER_APP: getEnv("VITE_APP_SCANNER_APP"),
  VITE_APP_FORM_APP: getEnv("VITE_APP_FORM_APP"),
  VITE_APP_DEFAULT_TENANT: getEnv("VITE_APP_DEFAULT_TENANT"),
  VITE_APP_SMART_SIGN_APP: getEnv("VITE_APP_SMART_SIGN_APP"),
};
